import { render } from "./CoBrandLinen.vue?vue&type=template&id=6d066618&scoped=true"
import script from "./CoBrandLinen.vue?vue&type=script&lang=js"
export * from "./CoBrandLinen.vue?vue&type=script&lang=js"

import "./CoBrandLinen.vue?vue&type=style&index=0&id=6d066618&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d066618"]])

export default __exports__